function setLoadingState(show) {
console.log('Godara');
  if(show) {
    document.body.classList.add('loading');
  } else {
    setTimeout(() => {
      document.body.classList.remove('loading');
    }, 1000);
  }
}


function getPreorderDate(selector) {
    const element = document.querySelector(selector);
    return element ? element.getAttribute('data-preorderdate')?.trim() : null;
}

window.addEventListener('DOMContentLoaded', function() {
  setLoadingState(false);
});


/*
document.querySelectorAll('a').forEach(link => link.addEventListener('click', function(event) {
  document.body.classList.remove('loading');
  const animate = link.dataset.noAnimation;
  cona
  if(link.target == '_blank' || animate) return;
  event.preventDefault();
  setLoadingState(true);
  setTimeout(() => {
    window.location = this.href;
  }, 200);
}));
*/

function kitDebounce(func, timeout = 50) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

class KitCarousel extends HTMLElement {
  constructor() {
    this.slider = this.querySelector(`#color-carousel--${handle}`);
  }

  init(handle) {
    document.addEventListener('DOMContentLoaded', function() {
      const swiper = new Swiper(`#color-carousel--${handle}`, {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 5,
        spaceBetween: 10,
        centeredSlides: true,
        slideToClickedSlide: true,
        767: {
          slidesPerView: 3,
          spaceBetween: 5
        },
        navigation: {
          nextEl: '.splide__arrow--next',
          prevEl: '.splide__arrow--prev',
        },
      });
  
      swiper.on('transitionEnd', (event) => {
        const swatchElement = document.querySelector(`#variant-swatch-${swiper.realIndex}`);
        if (swatchElement) {
          swatchElement.click();
        }
      });
    })
  }
}

if(!window.customElements.get('kit-carousel')) {
  window.customElements.define('kit-carousel', KitCarousel);
}

// Kit builder functionality
class KitSection extends HTMLElement {
  constructor() {
    super();
    this.options = this.querySelectorAll('[data-kit-option]');
    this.optionImages = this.querySelectorAll('[data-kit-option-image]'); 
    this.nextButton = this.querySelector('.button--kit-builder');
    this.stepType = this.dataset.step;
    this.helpLinks = this.querySelectorAll('[data-helper-link]');
    this.closeButton = this.querySelector('.kit-builder__overlay--close');
    this.kitFooter = document.querySelector('kit-footer-alt');
  }

  connectedCallback() {
    this._initEventListeners();
  }

  _initEventListeners() {
    this.options.forEach((option) => option.addEventListener('click', (event) => {
      this._handleOptionSelection(event, option);
      this._handleButtonUpdate(option);
    }));
    this.nextButton.addEventListener('click', function(event) {
      if (this.classList.contains('disabled')) {
        event.preventDefault(); 
      }
    });
    if(this.helpLinks) {
      this.helpLinks.forEach((link) => link.addEventListener('click', (event) => this._handleHelpLink(event, link)))
    }
    if(this.closeButton) {
      this.closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.helperOverlay.style.display = 'none';
        this.helperContent.style.display = 'none';
      })
    }
  }

  _handleHelpLink(e, link) {
    e.preventDefault();
    let helpType = link.dataset.helperContent;
    this.helperOverlay = this.querySelector(`.kit-builder__overlay`);
    this.helperContent = this.querySelector(`[data-helper-text="${helpType}"]`);
    this.helperOverlay.style.display = 'flex';
    this.helperOverlay.style.opacity = '0';
    this.helperContent.style.display = 'block';
    setTimeout(() => {
      this.helperOverlay.style.opacity = '1';
    }, 500)
  }

  _handleOptionSelection(e, option) {
    e.preventDefault();
    this.optionId = option.id;
    this.optionImages.forEach((image) => image.style.opacity = '0');
    document.querySelector(`#option-image-${this.optionId}`).style.opacity = '1';
    this.options.forEach(option => option.classList.remove('active'));
    option.classList.add('active');
  }

  _handleButtonUpdate(option) {
    this.kitFooter.updatePlaceholder(this.stepType, option.dataset.title);
    this.querySelector('.kit-builder__button-wrapper').classList.add('active');
    if(window.location.search) {
      if(this.stepType !== 'mesh-type') {
        if(this.stepType === 'installation-type') {
          this.updatedUrlParam = `?kit=${option.dataset.handle}`;
        } else {
          this.updatedUrlParam = `${window.location.search}${option.dataset.handle}`;
        }
      } else {
        this.updatedUrlParam = `${window.location.search}-${option.dataset.handle}`;
      }
    } else {
      this.updatedUrlParam = `?kit=`;
    }
    this.nextButton.innerText = `Choose ${option.dataset.title}`;
    if(this.stepType !== 'mesh-type') {
      this.nextButton.href = `${window.Theme.routes.root_url}pages/${option.dataset.url}${this.updatedUrlParam}`;
    } else {
      this.nextButton.href = `${window.Theme.routes.root_url}pages/gutter-guard-kits/${this.updatedUrlParam.replace('?kit=', '')}${window.location.search}`;
    }
    this.nextButton.classList.remove('disabled');
  }
};

if(!window.customElements.get('kit-section')) {
  window.customElements.define('kit-section', KitSection);
}


class MeshSizeSection extends KitSection {
  constructor()  {
    super();
    this.meshColor = document.querySelector('mesh-color');
    this.overlay = this.querySelector('[data-overlay]');
    this.kitFooter = document.querySelector('kit-footer');
    this.quantityInput = this.querySelector('[data-quantity-input]');
    this.quantityInput.addEventListener('change', (event) => this._handleQtyChange(event));
    this.querySelector('.kit-builder__button').addEventListener('click', () => {
      
      if(this.quantityInput.value == 0) {
        this.querySelector('.quantity-selector__wrapper').focus();
      }
    })
  }

  connectedCallback() {
    this._initEventListeners();
    this.kitSummary = document.querySelector('kit-summary');
  }

  init() {
    this.style.display = 'block';
    setLoadingState(false);
  }

  handleQtyChange(count) {
    this.handle = this.kitSummary.getProduct();
    if(count > 0 && this.handle) this.nextButton.classList.remove('disabled');
  }

  _handleButtonUpdate(option) {
    this.querySelector('.kit-builder__button-wrapper').classList.add('active');
    this.nextButton.innerText = `Choose ${option.dataset.title}`;
    if(this.quantityInput.value > 0) this.nextButton.classList.remove('disabled');
    this.productId = option.dataset.product;
    if(this.productId && this.kitSummary) {
      this.kitSummary.setProduct(this.productId);
      this.meshColor.setAttribute('data-mesh-product', this.productId);
    }

    if (this.nextButtonListener) {
      this.nextButton.removeEventListener('click', this.nextButtonListener);
    }

    this.nextButtonListener = (event) => {
      if(this.kitFooter) {
        this.kitFooter.updatePlaceholder('mesh-size', `${option.dataset.title} x ${this.quantityInput.value}m`);
      }
      event.preventDefault();
      this._fetchMeshProduct();
    };
    this.nextButton.addEventListener('click', this.nextButtonListener);
  }

  _fetchMeshProduct() {
    this.handle;
    if(this.kitSummary) {
      this.handle = this.kitSummary.getProduct();
    }
    setLoadingState(true);
    this.style.display = 'none';
    this.meshColor.init(this.handle);
  }
}

if(!window.customElements.get('mesh-size-section')) {
  window.customElements.define('mesh-size-section', MeshSizeSection);
}

class MeshColor extends HTMLElement {
  constructor() {
    super();
    this.stepType = this.dataset.step;
    this.currentProductColors = this.querySelector('[data-product-colors-placeholder]');
    this.currentProductGallery = this.querySelector('[data-product-image-placeholder]');

    this.productColours;

    this.addScrews = this.dataset.addScrews;
    this.screwHandle = this.dataset.screwHandle;
    
    this.colorSteps = document.querySelectorAll('color-step');

    this.kitSummary = document.querySelector('kit-summary');
    this.productCard = this.kitSummary.querySelector('.kit-summary__product--mesh');
    this.productLineItem = this.kitSummary.querySelector('.kit-summary__line-item.is-mesh');

    this.backButton = this.querySelector('.kit-builder__back');
    this.backButton.addEventListener('click', (event) => this._handleBackButton(event));

    this.kitFooter = document.querySelector('kit-footer');
  }

  connectedCallback() {
    this.nextButton = this.querySelector('.button--kit-builder');
  }

  _initHelperOverlay() {
    this.helpLinks = this.querySelectorAll('[data-helper-link]');
    this.closeButton = this.querySelector('.kit-builder__overlay--close');
    if(this.helpLinks) {
      this.helpLinks.forEach((link) => link.addEventListener('click', (event) => this._handleHelpLink(event, link)))
    }
    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.helperOverlay.style.display = 'none';
      this.helperContent.style.display = 'none';
    })
  }

  _handleHelpLink(e, link) {
    e.preventDefault();
    let helpType = link.dataset.helperContent;
    this.helperOverlay = this.querySelector(`[data-color-helper]`);
    this.helperContent = this.querySelector(`[data-helper-text="${helpType}"]`);
    this.helperOverlay.style.display = 'flex';
    this.helperOverlay.style.opacity = '0';
    this.helperContent.style.display = 'block';
    setTimeout(() => {
      this.helperOverlay.style.opacity = '1';
    }, 500)
  }

  init() {
    let productHandle = this.dataset.meshProduct;
    this.style.display = 'block';
    fetch(`/products/${productHandle}?view=kit-product`).then(response => response.text())
      .then(product => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(product, 'text/html');
        const productSection = doc.querySelector('[data-product-wrapper]');
        const productColors = productSection.querySelector('[data-product-colors]')
        const productGallery = productSection.querySelector('[data-product-gallery]');

        const staticProduct = doc.querySelector('[data-section-type="static-product"]'); 
        this.productSettings = JSON.parse(staticProduct.innerHTML); 
        this.product = this.productSettings.product;

        if(this.currentProductColors && productColors) {
          this.currentProductColors.innerHTML = productColors.outerHTML;
        }

        if(this.currentProductGallery && productGallery) {
          this.currentProductGallery.innerHTML = productGallery.outerHTML;
        }

        this._initSliders(this.product.handle);
        this._handleSliderChange(0);
        this._initSliderViewButtons(productHandle);
        this._initHelperOverlay();
        setLoadingState(false);
        })
      .catch();
  }


  _initSliderViewButtons(handle) {
    this.gridView = this.querySelector('[data-grid-view]');
    this.sliderView = this.querySelector('[data-slider-view]');
    this.colours = this.querySelector('color-selector');

    this.gridView.addEventListener('click', () => {
      if(!this.gridView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this.productColours.destroy(true, true);
        this.gridView.classList.add('active');
        this.sliderView.classList.remove('active');
        this.colours.classList.add('is-grid');
        this.colorSwatches = this.querySelectorAll('.is-grid .options-selection__option-value');
        if(this.colorSwatches) {
          this.colorSwatches.forEach((swatch, index) => swatch.addEventListener('click', (event) => {
            this.colorSwatches.forEach((swatch) => swatch.classList.remove('swiper-slide-active'))
            this._handleSliderChange(index);
            swatch.classList.add('swiper-slide-active');
          }));
        }
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
      }
    })

    this.sliderView.addEventListener('click', () => {
      if(!this.sliderView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this._initSliders(handle);
        this.sliderView.classList.add('active');
        this.gridView.classList.remove('active');
        this.colours.classList.remove('is-grid');
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
      }
    })
  }

  _initSliders(handle) {
    this.productColours = new Swiper(`#color-carousel--${handle}`, {
      direction: 'horizontal',
      effect: 'coverflow',
      loop: false,
      slidesPerView: 3,
      spaceBetween: 5,
      centeredSlides: true,
      slideToClickedSlide: true,
      pagination: {
        el: `.swiper-pagination--${handle}`,
        type: "progressbar",
      },
      coverflowEffect: {
        rotate: 20,
        stretch: 0,
        depth: 80,
        modifier: 1,
        scale: 0.85,
        slideShadows: false,
      },
      breakpointsBase: 'window',
      breakpoints: {
        767: {
          slidesPerView: 4,
          spaceBetween: 0
        }
      },
      navigation: {
        nextEl: '.splide__arrow--next',
        prevEl: '.splide__arrow--prev',
      },
    });
  
    
    this.main = new Swiper(`#main-carousel--${handle}`, {
      direction: 'horizontal',
      loop: true,
      effect: 'fade',
      navigation: {
        nextEl: '.arrows--main .kit-product__colours--arrow-next',
        prevEl: '.arrows--main .kit-product__colours--arrow-prev',
      },
    });
    this.productColours.on('transitionEnd', (event) => this._handleSliderChange(event.realIndex));
    
    this.querySelectorAll('[data-zoom-image]').forEach(function(img) {
      //new imageZoom(img);
    });
  }

  _handleSliderChange(index) {
    console.log('Meshcolour -only');
    const swatchElement = this.querySelector(`#variant-swatch-${index}`);
    if (swatchElement) {
      setTimeout(() => {
        this.selectedInput = swatchElement.querySelector('.options-selection__option-value-input');
        this.variantHandle = this.selectedInput.dataset.variantHandle;
        this.variantTitle = this.selectedInput.dataset.variantTitle;
        this.productHandle = this.selectedInput.dataset.product;
        this.variantId = this.selectedInput.value;
        this.isAvailable = this.selectedInput.dataset.variantOptionAvailable;
         this.variantPreorder = this.selectedInput.dataset.preorder;
         this.variantPreorderDate = this.selectedInput.dataset.preorderdate;
         this.variantStock = this.selectedInput.dataset.inventory;
         this.variantPolicy = this.selectedInput.dataset.inventorypolicy;
        this._updateVariantSelection(this.variantHandle);
        this._handleButtonUpdate(this.variantTitle, this.variantId, this.productHandle, this.isAvailable, this.variantPreorder, this.variantPreorderDate, this.variantStock, this.variantPolicy);
      }, 200);
    }
  }

  _updateVariantSelection(handle) {
    let firstMatchingIndex = -1;
    this.main.destroy(true, true);
    this.querySelectorAll('.product__slider .swiper-slide').forEach((image, index) => {
      image.style.display = 'none';
      let fileName = image.dataset.variant;
      if (fileName.includes(handle)) {
        image.style.display = 'block';
        if (firstMatchingIndex === -1) {
          firstMatchingIndex = index; 
        }
      }
    });
    this.main = new Swiper(`#main-carousel--${this.productHandle}`, {
      direction: 'horizontal',
      loop: false,
      effect: 'fade',
      navigation: {
        nextEl: '.arrows--main .kit-product__colours--arrow-next',
        prevEl: '.arrows--main .kit-product__colours--arrow-prev',
      },
    });
    if (firstMatchingIndex !== -1) {
      // this.main.slideTo(firstMatchingIndex, 10);
    }
  }

  _handleButtonUpdate(title, id, handle, available, preorder, preorderdate, stockval, inventpolicy) {
    /*if(available == 'false') {
      this.nextButton.innerText = `Sold out`;
      this.nextButton.classList.add('disabled');
      return;
    }*/
   // var pre_orderoption = '';
    console.log(preorder + inventpolicy);
    if(preorder == 'true'){

    }else{
        //console.log('Chkingss2', title);
      if(available == 'false') {
      this.nextButton.innerText = `Sold out`;
      this.nextButton.classList.add('disabled');
      return;
    }
    }

    this.querySelector('.kit-builder__button-wrapper').classList.add('active');
    this.nextButton.classList.remove('disabled');
    this.nextButton.innerText = `Choose ${title}`;
    this.nextStepValue = this.nextButton.dataset.nextStep;
  
    // Remove existing event listener if it exists
    if (this.nextButtonListener) {
      this.nextButton.removeEventListener('click', this.nextButtonListener);
      
    }
  
    if (this.nextStepValue === 'saddle') {
      this.nextStep = document.querySelector('saddle-color');
    } else {
      if (this.nextStepValue === 'trim') {
        this.nextStep = document.querySelector('trim-color');
      } else {
        this.nextStep = document.querySelector('kit-summary');
      }
    }
  
    this.nextButton.classList.remove('disabled');
    // Setup event listener for nextButton
    this.nextButtonListener = (event) => {
      event.preventDefault();
  
      setLoadingState(true);
      this.style.display = 'none';

      console.log('Mynextt3');
              if(preorder == 'true'){
      console.log('Chkingss', title);
    //  pre_orderoption = true;
      const mymesh_color = document.querySelector('.selected_meshdata');
      if(mymesh_color){
         if(preorder == 'true'){
           console.log('Chkingss_bbbb', title);
        mymesh_color.setAttribute('data-varid', id);
        mymesh_color.setAttribute('data-preorderdate', preorderdate);
         }else{
            console.log('Chkingss_cssss', title);
            mymesh_color.setAttribute('data-varid', '');
        mymesh_color.setAttribute('data-preorderdate', '');
         }
      }
    }else{
         const mymesh_color = document.querySelector('.selected_meshdata');
            mymesh_color.setAttribute('data-varid', '');
        mymesh_color.setAttribute('data-preorderdate', '');       
    }
  
      this.kitSummary.updateVariant('mesh', id, handle, title);
      if (this.addScrews) {
        // this.kitSummary.updateVariant('meshScrews', title, this.screwHandle, title);
        this.kitSummary.setMeshScrews('meshScrews', title, this.screwHandle, title); // Mesh screw specific additiona
      }
      if (this.kitFooter) {
        this.kitFooter.updatePlaceholder('mesh-color', `${title}`);
      }



       const atcButton = document.querySelector('.addcart_btnes');
const elementKits = document.querySelector('.pre-OrdersMessage');
const kit_dates = document.querySelector('.date_preorder');


if (atcButton) {
    const saddlePreorderDate = getPreorderDate('.selected_saddledata');
    const trimPreorderDate = getPreorderDate('.selected_trimdata');
    const meshPreorderDate = getPreorderDate('.selected_meshdata');

    const preorderDates = [saddlePreorderDate, trimPreorderDate, meshPreorderDate].filter(Boolean); // Get valid dates
    const preorderCount = preorderDates.length;

    if (preorderCount > 0) {
        
        atcButton.textContent = 'Pre-Order';
         elementKits.style.display = 'block';
      

     //set items pre-ordersss
      const mesh_preorder_msg = document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg .simple_preorder_msg');
      const saddle_preorder_msg = document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg .simple_preorder_msg');
      const trim_preorder_msg = document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg .simple_preorder_msg');

      if(mesh_preorder_msg){
        const mesh_preorderdate =  document.querySelector('.selected_meshdata').getAttribute('data-preorderdate');
        const mesh_preordrvarid =  document.querySelector('.selected_meshdata').getAttribute('data-varid');
        if(mesh_preorderdate != ''){
        mesh_preorder_msg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${mesh_preorderdate}`;
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').classList.add('activeme');
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').setAttribute('data-varid', mesh_preordrvarid);
        }else{
          mesh_preorder_msg.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').classList.remove('activeme');
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').setAttribute('data-varid', '');
        }
      }

            if(saddle_preorder_msg){
        const sad_preorderdate =  document.querySelector('.selected_saddledata').getAttribute('data-preorderdate');
        const sad_preordrvarid =  document.querySelector('.selected_saddledata').getAttribute('data-varid');
        if(sad_preorderdate != ''){
        saddle_preorder_msg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${sad_preorderdate}`;
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').classList.add('activeme');
           document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').setAttribute('data-varid', sad_preordrvarid);
        }else{
            saddle_preorder_msg.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').classList.remove('activeme');
           document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').setAttribute('data-varid', '');
        }
      }

            if(trim_preorder_msg){
        const trim_preorderdate =  document.querySelector('.selected_trimdata').getAttribute('data-preorderdate');
              const trim_preordrvarid =  document.querySelector('.selected_trimdata').getAttribute('data-varid');
        if(trim_preorderdate != ''){
        trim_preorder_msg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${trim_preorderdate}`;
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').classList.add('activeme');
          document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').setAttribute('data-varid', trim_preordrvarid);
        }else{
            trim_preorder_msg.innerHTML = ``;
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').classList.remove('activeme');
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').setAttribute('data-varid', '');
        }
      }
      
      
    }else{
      atcButton.textContent = 'Add To Cart';
         elementKits.style.display = 'none';

      const mesh_preorderdates =  document.querySelector('.selected_meshdata').getAttribute('data-preorderdate');
      const mesh_preorder_msgs = document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg .simple_preorder_msg');
       if(mesh_preorder_msgs){
       if(mesh_preorderdates == ''){
          mesh_preorder_msgs.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').classList.remove('activeme');
       }
       }


    const saddle_preorder_msgs = document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg .simple_preorder_msg');
     const sad_preorderdates =  document.querySelector('.selected_saddledata').getAttribute('data-preorderdate');
      if(saddle_preorder_msgs){
      if(sad_preorderdates == ''){
      saddle_preorder_msgs.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').classList.remove('activeme');
       }
      }


   const trim_preorder_msgs = document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg .simple_preorder_msg');
    const trim_preorderdates =  document.querySelector('.selected_trimdata').getAttribute('data-preorderdate');
       if(trim_preorder_msgs){
      if(trim_preorderdates == ''){
      trim_preorder_msgs.innerHTML = ``;
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').classList.remove('activeme');
       }
       }
      
      
    }
}
      
  
      this.nextStep.init();


      
    };
    this.nextButton.addEventListener('click', this.nextButtonListener);
  }
  

  _handleBackButton(e) {
    e.preventDefault();
    setLoadingState(true);
    this.style.display = 'none';
    document.querySelector('mesh-size-section').init();
  }
}

if(!window.customElements.get('mesh-color')) {
  window.customElements.define('mesh-color', MeshColor);
}


class SaddleColor extends HTMLElement {
  constructor() {
    super();
    this.handle = this.dataset.stepHandle;
    this.currentProductColors = this.querySelector('[data-product-colors-placeholder]');
    this.currentProductGallery = this.querySelector('[data-product-image-placeholder]');

    this.colorSteps = document.querySelectorAll('color-step');
    
    this.kitSummary = document.querySelector('kit-summary');
    this.productCard = this.kitSummary.querySelector('.kit-summary__product--saddles');
    this.productLineItem = this.kitSummary.querySelector('.kit-summary__line-item.is-saddle');
    this.screwProductCard = this.kitSummary.querySelector('.kit-summary__product--saddles-screws');
    this.productLineItemScrews = this.kitSummary.querySelector('.kit-summary__line-item.is-saddle-screws');

    this.screwImages = this.querySelector('[data-screw-image-placeholder]');

    this.matchToggle = this.querySelector('[data-match-toggle]');
    this.componentColorChoice = this.querySelector('[data-component] > .kit-summary__line-item--colour');
    this.screwColorChoice = this.querySelector('[data-screw] > .kit-summary__line-item--colour');
    this.screwOverlay = this.querySelector('screw-color');
    this.editScrew = this.querySelector('.is-editable');
    this.editScrew.addEventListener('click', () => {
      this.screwOverlay.show();
      this.matchToggle.checked = false;
    });

    this.screwsToggled = false;
    this.saddleRemovalButton = this.querySelector('[data-saddle-removal]');
    this.saddleRemovalOverlay = this.querySelector('[data-saddle-warning]');
    this.saddleRemovalClose = this.querySelector('[data-saddle-warning-close]');
    this.saddleRemovalConfirmation = this.querySelector('[data-saddle-removal-confirmation]');
    if(this.saddleRemovalButton) this.saddleRemovalButton.addEventListener('click', () => this._handleSaddleRemovalOverlay());
    if(this.saddleRemovalClose) this.saddleRemovalClose.addEventListener('click', () => {
      this.saddleRemovalOverlay.style.opacity = '0';
      setTimeout(() => {
        this.saddleRemovalOverlay.style.display = 'none';
      }, 200)
    });
    
    this.backButton = this.querySelector('.kit-builder__back');
    this.backButton.addEventListener('click', (event) => this._handleBackButton(event));

    this.kitFooter = document.querySelector('kit-footer');
  }

  connectedCallback() {
    this.nextButton = this.querySelector('.button--kit-builder');
  }

  _handleSaddleRemovalOverlay() {
    this.saddleRemovalOverlay.style.display = 'flex';
    this.saddleRemovalOverlay.querySelector('.kit-builer__overlay--text-content').style.display = 'block';
    setTimeout(() => {
      this.saddleRemovalOverlay.style.opacity = '1';
    }, 200);

    this.saddleRemovalConfirmation.removeEventListener('click', this.removeButtonListener);

    this.removeButtonListener = (event) => {
      event.preventDefault();
      this.nextStepValue = this.nextButton.dataset.nextStep;
      if(this.nextStepValue == 'trim') {
          this.nextStep = document.querySelector('trim-color');
      } else {
        this.nextStep = document.querySelector('kit-summary');
      }
      setLoadingState(true);
      this.style.display = 'none';
  
      this.kitFooter.updatePlaceholder('saddle-color', `No saddles`);
  
      this.saddleRemovalOverlay.style.opacity = '0';
      setTimeout(() => {
        this.saddleRemovalOverlay.style.display = 'none';
      }, 200)
  
      if(this.kitSummary) {
        this.kitSummary.toggleScrewQuantities('mesh');
        this.screwsToggled = true;
        this.kitSummary._updateTotalPrice();
      }
  
      this.nextStep.init();
    };
    this.saddleRemovalConfirmation.addEventListener('click', this.removeButtonListener);
  }

  _initHelperOverlay() {
    this.helpLinks = this.querySelectorAll('[data-helper-link]');
    this.closeButton = this.querySelector('.kit-builder__helper--close');
    if(this.helpLinks) {
      this.helpLinks.forEach((link) => link.addEventListener('click', (event) => this._handleHelpLink(event, link)))
    }
    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.helperOverlay.style.display = 'none';
      this.helperContent.style.display = 'none';
    })
  }

  _handleHelpLink(e, link) {
    e.preventDefault();
    let helpType = link.dataset.helperContent;
    this.helperOverlay = this.querySelector(`[data-color-helper]`);
    this.helperContent = this.querySelector(`[data-helper-text="${helpType}"]`);
    this.helperOverlay.style.display = 'flex';
    this.helperOverlay.style.opacity = '0';
    this.helperContent.style.display = 'block';
    setTimeout(() => {
      this.helperOverlay.style.opacity = '1';
    }, 500)
  }

  init() {
    setLoadingState(true);
    fetch(`/products/${this.handle}?view=kit-product`).then(response => response.text())
      .then(product => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(product, 'text/html');
        const productSection = doc.querySelector('[data-product-wrapper]');
        const productColors = productSection.querySelector('[data-product-colors]')
        const productGallery = productSection.querySelector('[data-product-gallery]');
  
        const staticProduct = doc.querySelector('[data-section-type="static-product"]'); 
        this.productSettings = JSON.parse(staticProduct.innerHTML); 
  
        this.context = this.productSettings.context;
        this.settings = this.productSettings.settings;
        this.product = this.productSettings.product;
  
        if(this.currentProductColors && productColors) {
          this.currentProductColors.innerHTML = productColors.outerHTML;
        }
  
        if(this.currentProductGallery && productGallery) {
          this.currentProductGallery.innerHTML = productGallery.outerHTML;
        }

        this.style.display = 'block';
        this.matchToggle.addEventListener('change', (event) => this._toggleScrewColor(event, this.matchToggle));
        setTimeout(() => {
          this._initSliders(this.handle);
          this.screwOverlay.init('saddle');
          this._initSliderViewButtons(this.handle);
          this._initHelperOverlay();
        }, 100);
        
    })
    .catch(error => {
      setLoadingState(false); 
      console.error('Error fetching product:', error);
    })
  }

  _initSliders(handle) {
    this.productColours = new Swiper(`#color-carousel--${handle}`, {
      direction: 'horizontal',
      effect: 'coverflow',
      loop: false,
      slidesPerView: 3,
      spaceBetween: 5,
      centeredSlides: true,
      slideToClickedSlide: true,
      pagination: {
        el: `.swiper-pagination--${handle}`,
        type: "progressbar",
      },
      coverflowEffect: {
        rotate: 20,
        stretch: 0,
        depth: 80,
        modifier: 1,
        scale: 0.85,
        slideShadows: false,
      },
      breakpointsBase: 'window',
      breakpoints: {
        767: {
          slidesPerView: 4,
          spaceBetween: 0
        }
      },
      navigation: {
        nextEl: '.splide__arrow--next',
        prevEl: '.splide__arrow--prev',
      },
    });
    
    this.main = new Swiper(`#main-carousel--${handle}`, {
      direction: 'horizontal',
      loop: false,
      effect: 'fade',
      navigation: {
        nextEl: '.arrows--main .kit-product__colours--arrow-next',
        prevEl: '.arrows--main .kit-product__colours--arrow-prev',
      },
    });
    this.productColours.on('transitionEnd', (event) => this._handleSliderChange(event.realIndex));

    this.querySelectorAll('.hover-trigger').forEach(function (element) {
      // new ImageZoom(element, {"zoomStyle": "backround: #ffffff", "fillContainer": true,"offset":{"vertical":0,"horizontal":10},"zoomPosition":"original","scale":"1.5"});
    });
  }

  slideTo(index) {
    this.productColours.slideTo(index, 50);
  }

  _initSliderViewButtons(handle) {
    this.gridView = this.querySelector('[data-grid-view]');
    this.sliderView = this.querySelector('[data-slider-view]');
    this.colours = this.querySelector('color-selector');

    this.gridView.addEventListener('click', () => {
      if(!this.gridView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this.productColours.destroy(true, true);
        this.gridView.classList.add('active');
        this.sliderView.classList.remove('active');
        this.colours.classList.add('is-grid');
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
        this.colorSwatches = this.querySelectorAll('.is-grid .options-selection__option-value');
        if(this.colorSwatches) {
          this.colorSwatches.forEach((swatch, index) => swatch.addEventListener('click', (event) => {
            this.colorSwatches.forEach((swatch) => swatch.classList.remove('swiper-slide-active'))
            this._handleSliderChange(index);
            swatch.classList.add('swiper-slide-active');
          }));
        }
      }
    })

    this.sliderView.addEventListener('click', () => {
      if(!this.sliderView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this._initSliders(handle);
        this.sliderView.classList.add('active');
        this.gridView.classList.remove('active');
        this.colours.classList.remove('is-grid');
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
      }
    })
  }

  _handleSliderChange(index) {
    console.log('Saddle-only');
    const swatchElement = this.querySelector(`#variant-swatch-${index}`);
    if (swatchElement) {
      setTimeout(() => {
        this.selectedInput = swatchElement.querySelector('.options-selection__option-value-input');
        this.variantHandle = this.selectedInput.dataset.variantHandle;
        this.variantTitle = this.selectedInput.dataset.variantTitle;
        this.productHandle = this.selectedInput.dataset.product;
        this.variantId = this.selectedInput.value;
        this.isAvailable = this.selectedInput.dataset.variantOptionAvailable;
         this.variantPreorder = this.selectedInput.dataset.preorder;
         this.variantPreorderDate = this.selectedInput.dataset.preorderdate;
         this.variantStock = this.selectedInput.dataset.inventory;
         this.variantPolicy = this.selectedInput.dataset.inventorypolicy;
        this._updateVariantSelection(this.variantHandle);
        this._handleButtonUpdate(this.variantTitle, this.variantId, this.productHandle, this.isAvailable, this.variantPreorder, this.variantPreorderDate, this.variantStock, this.variantPolicy);
        this._updateColorSelection(this.variantTitle); 
      }, 200);
    }
  }

  _updateVariantSelection(handle) {
    let firstMatchingIndex = -1;
    this.main.destroy(true, true);
    this.querySelectorAll('.product__slider .swiper-slide').forEach((image, index) => {
      image.style.display = 'none';
      let fileName = image.dataset.variant;
      if (fileName.includes(handle)) {
        image.style.display = 'block';
        if (firstMatchingIndex === -1) {
          firstMatchingIndex = index; 
        }
      }
    });
    this.main = new Swiper(`#main-carousel--${this.productHandle}`, {
      direction: 'horizontal',
      loop: false,
      effect: 'fade',
      navigation: {
        nextEl: '.arrows--main .kit-product__colours--arrow-next',
        prevEl: '.arrows--main .kit-product__colours--arrow-prev',
      },
    });
    if (firstMatchingIndex !== -1) {
      //this.main.slideTo(firstMatchingIndex, 10);
    }
  }

  _handleButtonUpdate(title, id, handle, available, preorder, preorderdate, stockval, inventpolicy) {
   /* if(available == 'false') {
      this.nextButton.innerText = `Sold out`;
      this.nextButton.classList.add('disabled');
      return;
    }*/
    
    if(preorder == 'true'){
   
    }else{
      if(available == 'false') {
      this.nextButton.innerText = `Sold out`;
      this.nextButton.classList.add('disabled');
      return;
    }
    }
    
    this.querySelector('.kit-builder__button-wrapper').classList.add('active');
    this.nextButton.innerText = `Confirm colours`;
    this.nextButton.classList.remove('disabled');
    this.nextStepValue = this.nextButton.dataset.nextStep;
  
    // Remove existing event listener if it exists
    if (this.nextButtonListener) {
      this.nextButton.removeEventListener('click', this.nextButtonListener);
    }
  
    if(this.nextStepValue == 'trim') {
        this.nextStep = document.querySelector('trim-color');
    } else {
      this.nextStep = document.querySelector('kit-summary');
    }
  
    this.nextButton.classList.remove('disabled');
    // Setup event listener for nextButton
    this.nextButtonListener = (event) => {
      event.preventDefault();
  
      setLoadingState(true);
      this.style.display = 'none';

        if(preorder == 'true'){
    //  pre_orderoption = true;
      const mysaddle_color = document.querySelector('.selected_saddledata');
      if(mysaddle_color){
        mysaddle_color.setAttribute('data-varid', id);
        mysaddle_color.setAttribute('data-preorderdate', preorderdate);
      }
    }else{
      const mysaddle_color = document.querySelector('.selected_saddledata');
      if(mysaddle_color){
        mysaddle_color.setAttribute('data-varid', '');
        mysaddle_color.setAttribute('data-preorderdate', '');
      }    
    }
      
      this.kitFooter.updatePlaceholder('saddle-color', `${title}`);
  
      if(this.kitSummary) {
        console.log('Saddle Summy');

const atcButton = document.querySelector('.addcart_btnes');
const elementKits = document.querySelector('.pre-OrdersMessage');
const kit_dates = document.querySelector('.date_preorder');


if (atcButton) {
    const saddlePreorderDate = getPreorderDate('.selected_saddledata');
    const trimPreorderDate = getPreorderDate('.selected_trimdata');
    const meshPreorderDate = getPreorderDate('.selected_meshdata');

    const preorderDates = [saddlePreorderDate, trimPreorderDate, meshPreorderDate].filter(Boolean); // Get valid dates
    const preorderCount = preorderDates.length;

    if (preorderCount > 0) {
     
        atcButton.textContent = 'Pre-Order';
         elementKits.style.display = 'block';
      

     //set items pre-ordersss
      const mesh_preorder_msg = document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg .simple_preorder_msg');
      const saddle_preorder_msg = document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg .simple_preorder_msg');
      const trim_preorder_msg = document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg .simple_preorder_msg');

      if(mesh_preorder_msg){
        const mesh_preorderdate =  document.querySelector('.selected_meshdata').getAttribute('data-preorderdate');
         const mesh_preordrvarid =  document.querySelector('.selected_meshdata').getAttribute('data-varid');
        if(mesh_preorderdate != ''){
        mesh_preorder_msg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${mesh_preorderdate}`;
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').classList.add('activeme');
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').setAttribute('data-varid', mesh_preordrvarid);
        }else{
          mesh_preorder_msg.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').classList.remove('activeme');
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').setAttribute('data-varid', '');
        }
      }

            if(saddle_preorder_msg){
        const sad_preorderdate =  document.querySelector('.selected_saddledata').getAttribute('data-preorderdate');
        const sad_preordrvarid =  document.querySelector('.selected_saddledata').getAttribute('data-varid');
        if(sad_preorderdate != ''){
        saddle_preorder_msg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${sad_preorderdate}`;
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').classList.add('activeme');
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').setAttribute('data-varid', sad_preordrvarid);
        }else{
            saddle_preorder_msg.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').classList.remove('activeme');
            document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').setAttribute('data-varid', '');
        }
      }

            if(trim_preorder_msg){
        const trim_preorderdate =  document.querySelector('.selected_trimdata').getAttribute('data-preorderdate');
                const trim_preordrvarid =  document.querySelector('.selected_trimdata').getAttribute('data-varid');
        if(trim_preorderdate != ''){
        trim_preorder_msg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${trim_preorderdate}`;
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').classList.add('activeme');
            document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').setAttribute('data-varid', trim_preordrvarid);
        }else{
            trim_preorder_msg.innerHTML = ``;
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').classList.remove('activeme');
            document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').setAttribute('data-varid', '');
        }
      }
      
      
    }else{
      atcButton.textContent = 'Add To Cart';
         elementKits.style.display = 'none';

            const mesh_preorderdates =  document.querySelector('.selected_meshdata').getAttribute('data-preorderdate');
      const mesh_preorder_msgs = document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg .simple_preorder_msg');
       if(mesh_preorder_msgs){
       if(mesh_preorderdates == ''){
          mesh_preorder_msgs.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').classList.remove('activeme');
       }
       }


    const saddle_preorder_msgs = document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg .simple_preorder_msg');
     const sad_preorderdates =  document.querySelector('.selected_saddledata').getAttribute('data-preorderdate');
      if(saddle_preorder_msgs){
      if(sad_preorderdates == ''){
      saddle_preorder_msgs.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').classList.remove('activeme');
       }
      }


   const trim_preorder_msgs = document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg .simple_preorder_msg');
    const trim_preorderdates =  document.querySelector('.selected_trimdata').getAttribute('data-preorderdate');
       if(trim_preorder_msgs){
      if(trim_preorderdates == ''){
      trim_preorder_msgs.innerHTML = ``;
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').classList.remove('activeme');
       }
       }
      
    }
}

         
        
        this.kitSummary.updateVariant('saddles', id, handle, title);
        if(this.screwsToggled) this.kitSummary.toggleScrewQuantities('saddles');
      }
  
      this.nextStep.init();
    };
    this.nextButton.addEventListener('click', this.nextButtonListener);
  }

  _updateColorSelection(title) {
    if(this.matchToggle.checked) {
      this.setScrewColor(title);
    }
    this.componentColorChoice.querySelector('span').innerText = title;
    this.componentColorChoice.querySelector('.kit-builder__swatch').style.background = `var(--${title.replace(' ', '')})`;
  }

  _toggleScrewColor(e, toggle) {
    e.stopPropagation();
    if(!toggle.checked) {
      this.screwOverlay.show();
    } else {
      this.setScrewColor(this.variantTitle);
    }
  }

  setScrewColor(title) {
    this.screwOption = this.screwOverlay.querySelector(`[data-variant-title="${title}"]`);
    this.screwId = this.screwOption.value;
    this.screwHandle = this.screwOption.dataset.product;
    this.kitSummary.updateVariant(`saddleScrews`, this.screwId, this.screwHandle, title);
    this.screwColorChoice.querySelector('span').innerText = title;
    this.screwColorChoice.querySelector('.kit-builder__swatch').style.background = `var(--${title.replace(' ', '')})`;
    this.screwImages.querySelectorAll('.product__images--screws > div').forEach((image) => image.style.opacity = '0');
    this.screwImages.querySelector(`[data-variant="${title}"]`).style.opacity = '1';
  }

 
  _handleBackButton(e) {
    e.preventDefault();
    setLoadingState(true);
    this.style.display = 'none';
    this.matchToggle.removeEventListener('change', this.toggleScrewColorHandler);
    document.querySelector('mesh-color').init();
  }
}

if(!window.customElements.get('saddle-color')) {
  window.customElements.define('saddle-color', SaddleColor);
}

class TrimColor extends HTMLElement {
  constructor() {
    super();
    this.handle = this.dataset.stepHandle;
    this.currentProductColors = this.querySelector('[data-product-colors-placeholder]');
    this.currentProductGallery = this.querySelector('[data-product-image-placeholder]');

    this.colorSteps = document.querySelectorAll('color-step');

    this.trimOptions = this.querySelectorAll('[data-kit-option]');
    if(this.trimOptions) {
      this.trimOptions.forEach((option) => {
        option.addEventListener('click', (event) => this._handleOptionSelection(event, option));
      })
    }
    
    this.kitSummary = document.querySelector('kit-summary');
    this.productCard = this.kitSummary.querySelector('.kit-summary__product--trim');
    this.productLineItem = this.kitSummary.querySelector('.kit-summary__line-item.is-trim');
    this.screwProductCard = this.kitSummary.querySelector('.kit-summary__product--trim-screws');
    this.productLineItemScrews = this.kitSummary.querySelector('.kit-summary__line-item.is-trim-screws');

    this.screwImages = this.querySelector('[data-screw-image-placeholder]');

    this.matchToggle = this.querySelector('[data-match-toggle]');
    this.componentColorChoice = this.querySelector('[data-component] > .kit-summary__line-item--colour');
    this.screwColorChoice = this.querySelector('[data-screw] > .kit-summary__line-item--colour');
    this.screwOverlay = this.querySelector('screw-color');
    this.editScrew = this.querySelector('.is-editable');
    this.editScrew.addEventListener('click', () => {
      this.screwOverlay.show();
      this.matchToggle.checked = false;
    });

    this.backButton = this.querySelector('.kit-builder__back');
    this.backButton.addEventListener('click', (event) => this._handleBackButton(event));

    this.kitFooter = document.querySelector('kit-footer');
  }

  _handleOptionSelection(e, option) {
    e.preventDefault();
    if(option.classList.contains('active')) return;
    const optionHandle = option.dataset.handle;
    if (this.handle !== optionHandle) { // Check if the handle is different
      this.handle = optionHandle;
      this.setAttribute('data-step-handle', this.handle);
      this.init();
    }
    this.trimOptions.forEach(option => option.classList.remove('active'));
    option.classList.add('active');
  }

  connectedCallback() {
    this.nextButton = this.querySelector('.button--kit-builder');
  }

  _initHelperOverlay() {
    this.helpLinks = this.querySelectorAll('[data-helper-link]');
    this.closeButton = this.querySelector('.kit-builder__helper--close');
    if(this.helpLinks) {
      this.helpLinks.forEach((link) => link.addEventListener('click', (event) => this._handleHelpLink(event, link)))
    }
    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.helperOverlay.style.display = 'none';
      this.helperContent.style.display = 'none';
    })
  }

  _handleHelpLink(e, link) {
    e.preventDefault();
    let helpType = link.dataset.helperContent;
    this.helperOverlay = this.querySelector(`[data-color-helper]`);
    this.helperContent = this.querySelector(`[data-helper-text="${helpType}"]`);
    this.helperOverlay.style.display = 'flex';
    this.helperOverlay.style.opacity = '0';
    this.helperContent.style.display = 'block';
    setTimeout(() => {
      this.helperOverlay.style.opacity = '1';
    }, 500)
  }

  init() {
    setLoadingState(true);
    fetch(`/products/${this.handle}?view=kit-product`).then(response => response.text())
      .then(product => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(product, 'text/html');
        const productSection = doc.querySelector('[data-product-wrapper]');
        const productColors = productSection.querySelector('[data-product-colors]')
        const productGallery = productSection.querySelector('[data-product-gallery]');
  
        const staticProduct = doc.querySelector('[data-section-type="static-product"]'); 
        this.productSettings = JSON.parse(staticProduct.innerHTML); 
  
        this.context = this.productSettings.context;
        this.settings = this.productSettings.settings;
        this.product = this.productSettings.product;
  
        if(this.currentProductColors && productColors) {
          this.currentProductColors.innerHTML = productColors.outerHTML;
        }
  
        if(this.currentProductGallery && productGallery) {
          this.currentProductGallery.innerHTML = productGallery.outerHTML;
        }

        this.style.display = 'block';
        this.toggleScrewColorHandler = () => this._toggleScrewColor(this.matchToggle);
        this.matchToggle.addEventListener('change', this.toggleScrewColorHandler);
        this._initSliders(this.handle);
        this._initSliderViewButtons(this.handle);
        this.screwOverlay.init('trim');
        this._initHelperOverlay();
      })
      .catch(error => {
        setLoadingState(false); // Ensure loading state is removed in case of error
        console.error('Error fetching product:', error);
      })
  }

  _initSliders(handle) {
    this.productColours = new Swiper(`#color-carousel--${handle}`, {
      direction: 'horizontal',
      effect: 'coverflow',
      loop: false,
      slidesPerView: 3,
      spaceBetween: 5,
      centeredSlides: true,
      slideToClickedSlide: true,
      pagination: {
        el: `.swiper-pagination--${handle}`,
        type: "progressbar",
      },
      coverflowEffect: {
        rotate: 20,
        stretch: 0,
        depth: 80,
        modifier: 1,
        scale: 0.85,
        slideShadows: false,
      },
      breakpointsBase: 'window',
      breakpoints: {
        767: {
          slidesPerView: 4,
          spaceBetween: 0
        }
      },
      navigation: {
        nextEl: '.splide__arrow--next',
        prevEl: '.splide__arrow--prev',
      },
    });

    this.main = new Swiper(`#main-carousel--${handle}`, {
      direction: 'horizontal',
      loop: false,
      effect: 'fade',
      navigation: {
        nextEl: '.arrows--main .kit-product__colours--arrow-next',
        prevEl: '.arrows--main .kit-product__colours--arrow-prev',
      },
    });
    this.productColours.on('transitionEnd', (event) => this._handleSliderChange(event.realIndex));

    this.querySelectorAll('.hover-trigger').forEach(function (element) {
      // new ImageZoom(element, {"zoomStyle": "backround: #ffffff", "fillContainer": true,"offset":{"vertical":0,"horizontal":10},"zoomPosition":"original","scale":"1.5"});
    });
  }

  slideTo(index) {
    this.productColours.slideTo(index, 50);
  }

  _initSliderViewButtons(handle) {
    this.gridView = this.querySelector('[data-grid-view]');
    this.sliderView = this.querySelector('[data-slider-view]');
    this.colours = this.querySelector('color-selector');

    this.gridView.addEventListener('click', () => {
      if(!this.gridView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this.productColours.destroy(true, true);
        this.gridView.classList.add('active');
        this.sliderView.classList.remove('active');
        this.colours.classList.add('is-grid');
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
        this.colorSwatches = this.querySelectorAll('.is-grid .options-selection__option-value');
        if(this.colorSwatches) {
          this.colorSwatches.forEach((swatch, index) => swatch.addEventListener('click', (event) => {
            this.colorSwatches.forEach((swatch) => swatch.classList.remove('swiper-slide-active'))
            this._handleSliderChange(index);
            swatch.classList.add('swiper-slide-active');
          }));
        }
      }
    })

    this.sliderView.addEventListener('click', () => {
      if(!this.sliderView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this._initSliders(handle);
        this.sliderView.classList.add('active');
        this.gridView.classList.remove('active');
        this.colours.classList.remove('is-grid');
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
      }
    })
  }

  _handleSliderChange(index) {
    console.log('Trim only');
    const swatchElement = this.querySelector(`#variant-swatch-${index}`);
    if (swatchElement) {
      setTimeout(() => {
        this.selectedInput = swatchElement.querySelector('.options-selection__option-value-input');
        this.variantHandle = this.selectedInput.dataset.variantHandle;
        this.variantTitle = this.selectedInput.dataset.variantTitle;
        this.productHandle = this.selectedInput.dataset.product;
        this.variantId = this.selectedInput.value;
        this.isAvailable = this.selectedInput.dataset.variantOptionAvailable;
         this.variantPreorder = this.selectedInput.dataset.preorder;
         this.variantPreorderDate = this.selectedInput.dataset.preorderdate;
         this.variantStock = this.selectedInput.dataset.inventory;
         this.variantPolicy = this.selectedInput.dataset.inventorypolicy;
        this._updateVariantSelection(this.variantHandle);
        this._handleButtonUpdate(this.variantTitle, this.variantId, this.productHandle, this.isAvailable, this.variantPreorder, this.variantPreorderDate, this.variantStock, this.variantPolicy);
        this._updateColorSelection(this.variantTitle, this.variantId, this.productHandle);
      }, 200);
    }
  }

  _updateVariantSelection(handle) {
    let firstMatchingIndex = -1;
    this.main.destroy(true, true);
    this.querySelectorAll('.product__slider .swiper-slide').forEach((image, index) => {
      image.style.display = 'none';
      let fileName = image.dataset.variant;
      if (fileName.includes(handle)) {
        image.style.display = 'block';
        if (firstMatchingIndex === -1) {
          firstMatchingIndex = index;
        }
      }
    });
    this.main = new Swiper(`#main-carousel--${this.productHandle}`, {
      direction: 'horizontal',
      loop: false,
      effect: 'fade',
      navigation: {
        nextEl: '.arrows--main .kit-product__colours--arrow-next',
        prevEl: '.arrows--main .kit-product__colours--arrow-prev',
      },
    });
    if (firstMatchingIndex !== -1) {
      //this.main.slideTo(firstMatchingIndex, 10);
    }
  } 

  _handleButtonUpdate(title, id, handle, available, preorder, preorderdate, stockval, inventpolicy) {
   /* if(available == 'false') {
      this.nextButton.innerText = `Sold out`;
      this.nextButton.classList.add('disabled');
      return;
    }*/

    if(preorder == 'true'){
   
    }else{
      if(available == 'false') {
      this.nextButton.innerText = `Sold out`;
      this.nextButton.classList.add('disabled');
      return;
    }
    }
    
    this.querySelector('.kit-builder__button-wrapper').classList.add('active');
    this.nextButton.innerText = `Confirm colours`;
    this.nextButton.classList.remove('disabled');
  
    // Remove existing event listener if it exists
    if (this.nextButtonListener) {
      this.nextButton.removeEventListener('click', this.nextButtonListener);
    }
  
    if(this.nextStepValue == 'trim') {
        this.nextStep = document.querySelector('trim-color');
    } else {
      this.nextStep = document.querySelector('kit-summary');
    }
  
    this.nextButton.classList.remove('disabled');
    // Setup event listener for nextButton
    this.nextButtonListener = (event) => {
      event.preventDefault();
  
      setLoadingState(true);
      this.style.display = 'none';


     if(preorder == 'true'){
    //  pre_orderoption = true;
      const mytrim_color = document.querySelector('.selected_trimdata');
      if(mytrim_color){
        mytrim_color.setAttribute('data-varid', id);
        mytrim_color.setAttribute('data-preorderdate', preorderdate);
      }
    }else{
       const mytrim_color = document.querySelector('.selected_trimdata');
      if(mytrim_color){
        mytrim_color.setAttribute('data-varid', '');
        mytrim_color.setAttribute('data-preorderdate', '');
      }
    }

      
      if(this.kitSummary) {

                 console.log('hello summaru trim');

const atcButton = document.querySelector('.addcart_btnes');
const elementKits = document.querySelector('.pre-OrdersMessage');
const kit_dates = document.querySelector('.date_preorder');


if (atcButton) {
    const saddlePreorderDate = getPreorderDate('.selected_saddledata');
    const trimPreorderDate = getPreorderDate('.selected_trimdata');
    const meshPreorderDate = getPreorderDate('.selected_meshdata');

    const preorderDates = [saddlePreorderDate, trimPreorderDate, meshPreorderDate].filter(Boolean); // Get valid dates
    const preorderCount = preorderDates.length;

    if (preorderCount > 0) {
        atcButton.textContent = 'Pre-Order';
 elementKits.style.display = 'block';
        if (kit_dates) {
            if (preorderCount > 1) {
                //kit_dates.innerHTML = `Later available date.`; // Show all dates
            } else {
               // kit_dates.innerHTML = `Pre-Order Date: ${preorderDates[0]}`; // Show the only available date
            }
        }

     //set items pre-ordersss
      const mesh_preorder_msg = document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg .simple_preorder_msg');
      const saddle_preorder_msg = document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg .simple_preorder_msg');
      const trim_preorder_msg = document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg .simple_preorder_msg');

      if(mesh_preorder_msg){
        const mesh_preorderdate =  document.querySelector('.selected_meshdata').getAttribute('data-preorderdate');
         const mesh_preordrvarid =  document.querySelector('.selected_meshdata').getAttribute('data-varid');
        if(mesh_preorderdate != ''){
        mesh_preorder_msg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${mesh_preorderdate}`;
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').classList.add('activeme');
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').setAttribute('data-varid', mesh_preordrvarid);
        }else{
           mesh_preorder_msg.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').classList.remove('activeme');
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').setAttribute('data-varid', '');
        }
      }

            if(saddle_preorder_msg){
        const sad_preorderdate =  document.querySelector('.selected_saddledata').getAttribute('data-preorderdate');
              const sad_preordrvarid =  document.querySelector('.selected_saddledata').getAttribute('data-varid');
        if(sad_preorderdate != ''){
        saddle_preorder_msg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${sad_preorderdate}`;
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').classList.add('activeme');
           document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').setAttribute('data-varid', sad_preordrvarid);
        }else{
          saddle_preorder_msg.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').classList.remove('activeme');
           document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').setAttribute('data-varid', '');
        }
      }

            if(trim_preorder_msg){
        const trim_preorderdate =  document.querySelector('.selected_trimdata').getAttribute('data-preorderdate');
              const trim_preordrvarid =  document.querySelector('.selected_trimdata').getAttribute('data-varid');
        if(trim_preorderdate != ''){
        trim_preorder_msg.innerHTML = `Pre-Order - Estimated Shipping ETA Between: ${trim_preorderdate}`;
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').classList.add('activeme');
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').setAttribute('data-varid', trim_preordrvarid);
        }else{
          trim_preorder_msg.innerHTML = ``;
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').classList.remove('activeme');
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').setAttribute('data-varid', '');
        }
      }
      
      
    }else{
       atcButton.textContent = 'Add To Cart';
 elementKits.style.display = 'none';
      const mesh_preorderdates =  document.querySelector('.selected_meshdata').getAttribute('data-preorderdate');
      const mesh_preorder_msgs = document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg .simple_preorder_msg');
       if(mesh_preorder_msgs){
       if(mesh_preorderdates == ''){
          mesh_preorder_msgs.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.mesh_preorder_msg').classList.remove('activeme');
       }
       }


    const saddle_preorder_msgs = document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg .simple_preorder_msg');
     const sad_preorderdates =  document.querySelector('.selected_saddledata').getAttribute('data-preorderdate');
      if(saddle_preorder_msgs){
      if(sad_preorderdates == ''){
      saddle_preorder_msgs.innerHTML = ``;
          document.querySelector('.kit-summary__line-item--pre-order.saddle_preorder_msg').classList.remove('activeme');
       }
      }


   const trim_preorder_msgs = document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg .simple_preorder_msg');
    const trim_preorderdates =  document.querySelector('.selected_trimdata').getAttribute('data-preorderdate');
       if(trim_preorder_msgs){
      if(trim_preorderdates == ''){
      trim_preorder_msgs.innerHTML = ``;
           document.querySelector('.kit-summary__line-item--pre-order.trim_preorder_msg').classList.remove('activeme');
       }
       }
      
    }
}
        
        this.kitSummary.updateVariant('trim', id, handle, title);
      }
      if(this.kitFooter) {
        this.kitFooter.updatePlaceholder('trim-color', `${title}`);
      }
  
      this.nextStep.init();
    };
    this.nextButton.addEventListener('click', this.nextButtonListener);
  }


  _updateColorSelection(title, id, handle) {
    if(this.matchToggle.checked) {
      this.setScrewColor(title);
    }
    this.componentColorChoice.querySelector('span').innerText = title;
    this.componentColorChoice.querySelector('.kit-builder__swatch').style.background = `var(--${title.replace(' ', '')})`;
  }

  _toggleScrewColor(toggle) {
    if(!toggle.checked) {
      this.screwOverlay.show();
    } else {
      this.setScrewColor(this.variantTitle);
    }
  }

  setScrewColor(title) {
    this.screwOption = this.screwOverlay.querySelector(`[data-variant-title="${title}"]`);
    this.screwId = this.screwOption.value;
    this.screwHandle = this.screwOption.dataset.product;
    this.kitSummary.updateVariant(`trimScrews`, this.screwId, this.screwHandle, title);
    this.screwColorChoice.querySelector('span').innerText = title;
    this.screwColorChoice.querySelector('.kit-builder__swatch').style.background = `var(--${title.replace(' ', '')})`;
    this.screwImages.querySelectorAll('.product__images--screws > div').forEach((image) => image.style.opacity = '0');
    this.screwImages.querySelector(`[data-variant="${title}"]`).style.opacity = '1';
  }

  _handleBackButton(e) {
    e.preventDefault();
    setLoadingState(true);
    this.style.display = 'none';
    document.querySelector('saddle-color').init();
  }
}

if(!window.customElements.get('trim-color')) {
  window.customElements.define('trim-color', TrimColor);
}

class ScrewColor extends HTMLElement {
  constructor() {
    super();
    this.handle = this.dataset.stepHandle;
    this.nextButton = this.querySelector('[data-choose-color]');
    this.currentProductColors = this.querySelector('[data-product-colors-placeholder]');
    
    this.kitSummary = document.querySelector('kit-summary');
    this.productCard = this.kitSummary.querySelector('.kit-summary__product--trim');
    this.productLineItem = this.kitSummary.querySelector('.kit-summary__line-item.is-trim');
    this.screwProductCard = this.kitSummary.querySelector('.kit-summary__product--trim-screws');
    this.productLineItemScrews = this.kitSummary.querySelector('.kit-summary__line-item.is-trim-screws');

    this.screwColorChoice = this.querySelector('[data-screw] > .kit-summary__line-item--colour');

    this.helperText = this.querySelector('[data-screw-color-helper]');
    
    this.helperLink = this.querySelector('.kit-builder__helper-link');
    if(this.helperLink) this.helperLink.addEventListener('click', () => this._handleHelperText(true));
    
    this.helperTextClose = this.querySelector('.kit-builder__screw-helper--close');
    if(this.helperTextClose) this.helperTextClose.addEventListener('click', () => this._handleHelperText(false));

 

    this.closeButton = this.querySelector('.kit-builder__screw--close');
    if(this.helperTextClose) this.helperTextClose.addEventListener('click', () => this._handleHelperText(false));
  }

  connectedCallback() {
    
  }

  _handleHelperText(show) {
    if(show) {
      this.helperText.style.display = 'block';
      setTimeout(() => {
        this.helperText.style.opacity = '1';
      }, 200)
    } else {
      this.helperText.style.opacity = '0';
      
      setTimeout(() => {
        this.helperText.style.display = 'none';
      }, 200)
    }
  }

  init(context) {
    this.context = context;
    fetch(`/products/${this.handle}?view=kit-product`).then(response => response.text())
      .then(product => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(product, 'text/html');
        const productSection = doc.querySelector('[data-product-wrapper]');
        const productColors = productSection.querySelector('[data-product-colors]')
        const productGallery = productSection.querySelector('[data-product-gallery]');
        this.currentProductGallery = document.querySelector(`${this.context}-color [data-screw-image-placeholder]`);
        const staticProduct = doc.querySelector('[data-section-type="static-product"]'); 
        this.productSettings = JSON.parse(staticProduct.innerHTML); 
        this.product = this.productSettings.product;
  
        if(this.currentProductColors && productColors) {
          this.currentProductColors.innerHTML = productColors.outerHTML;
        }

        if(this.currentProductGallery && productGallery) {
          this.currentProductGallery.innerHTML = productGallery.outerHTML;
        }
        
        if(this.context == 'saddles') {
          this.preSelectedColor = this.kitSummary.fetchPreselectedColor(`saddles`);
        } else {
          this.preSelectedColor = this.kitSummary.fetchPreselectedColor(`trim`);
        }

        if(this.preSelectedColor){
          this.initialSlide = this.querySelector(`input[data-variant-title="${this.preSelectedColor}"]`);
          this.initialContext = document.querySelector(`${this.context}-color input[data-variant-title="${this.preSelectedColor}"]`);
          if(this.initialSlide && this.initialContext) { 
            this.initialIndex = this.initialSlide.dataset.index;
            this.initialContextIndex = this.initialContext.dataset.index;
          } else {
            this.initialIndex = 0;
            this.initialContextIndex = 0;
          }
          document.querySelector(`${this.context}-color`).productColours.slideTo(this.initialContextIndex, 10);
          document.querySelector(`${this.context}-color`)._handleSliderChange(this.initialContextIndex);
        } else {
          this._handleSliderChange(0);
          document.querySelector(`${this.context}-color`)._handleSliderChange(0);
        }
        setLoadingState(false);
      })
      .catch(error => {
        console.error('Error fetching product:', error);
      })

    this.closeButton.addEventListener('click', () => {
      this.style.display = 'none';
      document.querySelector(`[data-match-toggle-${this.context}]`).checked = true;
    })
  }

  show() {
    this.style.display = 'flex';
    this.style.opacity = '0';
    if(!this.productColours) {
      this._initSliders(this.handle);
      this._initSliderViewButtons(this.handle);
    }
    setTimeout(() => {
      this.style.opacity = '1';
    }, 500);
  }

  _initSliders(handle) {
    // Initialize Swiper
    this.slider = this.querySelector(`#color-carousel--${handle}`);
    this.slider.classList.add(`slider--${this.context}`);
    this.productColours = new Swiper(`.slider--${this.context}`, {
      direction: 'horizontal',
      effect: 'coverflow',
      loop: false,
      slidesPerView: 3,
      spaceBetween: 5,
      centeredSlides: true,
      slideToClickedSlide: true,
      pagination: {
        el: `.swiper-pagination--${handle}`,
        type: "progressbar",
      },
      coverflowEffect: {
        rotate: 20,
        stretch: 0,
        depth: 80,
        modifier: 1,
        scale: 0.85,
        slideShadows: false,
      },
      breakpointsBase: 'window',
      breakpoints: {
        767: {
          slidesPerView: 4,
          spaceBetween: 0
        }
      },
      navigation: {
        nextEl: '.splide__arrow--next',
        prevEl: '.splide__arrow--prev',
      },
    });
    this.productColours.on('transitionEnd', (event) => this._handleSliderChange(event.realIndex));

  }

  _initSliderViewButtons(handle) {
    this.gridView = this.querySelector('[data-grid-view]');
    this.sliderView = this.querySelector('[data-slider-view]');
    this.colours = this.querySelector('color-selector');

    this.gridView.addEventListener('click', () => {
      if(!this.gridView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this.productColours.destroy(true, true);
        this.gridView.classList.add('active');
        this.sliderView.classList.remove('active');
        this.colours.classList.add('is-grid');
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
        this.colorSwatches = this.querySelectorAll('.is-grid .options-selection__option-value');
        if(this.colorSwatches) {
          this.colorSwatches.forEach((swatch, index) => swatch.addEventListener('click', () => {
            this.colorSwatches.forEach((swatch) => swatch.classList.remove('swiper-slide-active'))
            this._handleSliderChange(index);
            swatch.classList.add('swiper-slide-active');
          }));
        }
      }
    })

    this.sliderView.addEventListener('click', () => {
      if(!this.sliderView.classList.contains('active')) {
        this.classList.add('changing-layouts');
        this._initSliders(handle);
        this.sliderView.classList.add('active');
        this.gridView.classList.remove('active');
        this.colours.classList.remove('is-grid');
        setTimeout(() => {
          this.classList.remove('changing-layouts');
        }, 1000)
      }
    })
  }

  _handleSliderChange(index) {
    const swatchElement = this.querySelector(`#variant-swatch-${index}`);
    if (swatchElement) {
      setTimeout(() => {
        this.selectedInput = swatchElement.querySelector('.options-selection__option-value-input');
        this.variantHandle = this.selectedInput.dataset.variantHandle;
        this.variantTitle = this.selectedInput.dataset.variantTitle;
        this.productHandle = this.selectedInput.dataset.product;
        this.variantId = this.selectedInput.value;
        this.isAvailable = this.selectedInput.dataset.variantOptionAvailable;
        //this._updateVariantSelection(this.variantHandle);
        this._handleButtonUpdate(this.variantTitle, this.variantId, this.productHandle, this.isAvailable);
        //this._updateColorSelection(this.variantTitle); 
      }, 200);
    }
  }

  _handleButtonUpdate(title, id, handle, available) {
    if(available == 'false') {
      this.nextButton.innerText = `Sold out`;
      this.nextButton.classList.add('disabled');
      return;
    }
    this.nextButton.innerText = `Choose ${title}`;
    this.nextButton.classList.remove('disabled');
  
    // Remove existing event listener if it exists
    if (this.nextButtonListener) {
      this.nextButton.removeEventListener('click', this.nextButtonListener);
    }

    // Setup event listener for nextButton
    this.nextButtonListener = (event) => {
      event.preventDefault();
      this.kitSummary.updateVariant(`${this.context}Screws`, id, handle, title);
      document.querySelector(`${this.context}-color`).setScrewColor(title);
      this.style.display = 'none';
    };
    this.nextButton.addEventListener('click', this.nextButtonListener);
  }
}

if(!window.customElements.get('screw-color')) {
  window.customElements.define('screw-color', ScrewColor);
}

class KitQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.field = this.querySelector('[data-quantity-selector]');
    this.input = this.querySelector('[data-quantity-input]');
    this.plus = this.querySelector('[data-quantity-plus]');
    this.minus = this.querySelector('[data-quantity-minus]');
    this.minusButtonWrapper = this.querySelector('[data-button-wrapper-minus]');
    this.incrementValue = parseInt(this.input.dataset.incrementValue, 10);
    this.increaseAmount = this.increaseAmount.bind(this);
    this.decreaseAmount = this.decreaseAmount.bind(this);
    this.onChange = kitDebounce((e) => this.onChange(e));
    this.meshSize = document.querySelector('mesh-size-section');
    this.kitSummary = document.querySelector('kit-summary');
    this.registerEvents();
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      const initialQuantity = parseInt(Math.round(this._getCount() / 10) * 10);
      this._updateSummary(initialQuantity);
    });
  }

  registerEvents() {
    this.plus.addEventListener('click', (e) => this.increaseAmount(e));
    this.minus.addEventListener('click', (e) => this.decreaseAmount(e));
    this.input.addEventListener('change', (e) => this.setAmount(e));
    this.input.addEventListener('keyup', (e) => this.quantityKeyUp(e));
    this.input.addEventListener('keydown', (e) => this.quantityKeyDown(e));

    this._updateMinusButton();
  }

  setAmount(e) {
    e.preventDefault();
    let count = Math.round(this._getCount() / 10) * 10;
    if (!count) {
      count = this.incrementValue;
    }
    this.input.value = count;
    this._updateMinusButton();
    this.onChange(e);
    this._updateSummary(count);
}

  _getCount() {
    return this.input.valueAsNumber;
  }

  increaseAmount(e) {
    e.preventDefault();
    let count = this._getCount();
    this.input.value = count + this.incrementValue;
    this._updateMinusButton();
    this.onChange(e.currentTarget);
    this._updateSummary(this.input.value);
  }

  decreaseAmount(e) {
    e.preventDefault();
    let count = this._getCount();
    this.input.value = count - this.incrementValue;
    this._updateMinusButton();
    this.onChange(e.currentTarget);
    this._updateSummary(this.input.value);
  }

  quantityKeyUp(e) {
    if (e.key === 'Backspace') {
      return;
    }
    this._updateMinusButton();
    this.onChange(e.currentTarget);
  }

  quantityKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  _updateMinusButton() {
    const count = this._getCount();
    if (count <= this.incrementValue) {
      this.minusButtonWrapper.classList.add('quantity-selector__button-wrapper--disabled');
    } else {
      this.minusButtonWrapper.classList.remove('quantity-selector__button-wrapper--disabled');
    }
  }

  _updateSummary(count) {
    if(this.kitSummary) {
      this.kitSummary.updateQuantity(parseInt(count));
    }
    if(this.meshSize) {
      this.meshSize.handleQtyChange(parseInt(count));
    }
  }

  unload() {
    this.events.unregisterAll();
  }
}

if (!window.customElements.get('kit-quantity-selector')) {
  window.customElements.define('kit-quantity-selector', KitQuantitySelector);
}

class KitSummary extends HTMLElement {
  constructor() {
    super();
    this.productId;
    this.kitName = this.dataset.kitName;
    this.internalOrdering = this.dataset.internalOrdering;

    this.priceElement = this.querySelector('[data-price-regular]');
    this.compareAtPriceElement = this.querySelector('[data-price-compare]');

    this.addToCartButton = this.querySelector('[data-add-to-cart]');
    if(this.addToCartButton) this.addToCartButton.addEventListener('click', (event) => this._handleAddToCart(event, this.addToCartButton))

    this.saddleMultiplier = parseFloat(this.dataset.saddleMultiplier);
    this.saddleScrewMultiplier = parseFloat(this.dataset.saddleScrewMultiplier);
    this.trimScrewMultiplier = parseFloat(this.dataset.trimScrewMultiplier);
    this.meshScrewMultiplier = parseFloat(this.dataset.meshScrewMultiplier);

    this.customerType = this.dataset.customerType;
    this.retailDiscount = this.dataset.retailDiscount;
    this.tradeDiscount = this.dataset.tradeDiscount;
    this.wholesaleDiscount = this.dataset.wholesaleDiscount;

    switch (this.customerType) {
      case 'retail':
        this.discount = this.retailDiscount;
        break;
      case 'trade':
        this.discount = this.tradeDiscount;
        break;
      case 'wholesale':
        this.discount = this.wholesaleDiscount;
        break;
    }

    this.lineItemEditButtons = this.querySelectorAll('.is-editable');
    if(this.lineItemEditButtons) {
      this.lineItemEditButtons.forEach((button) => button.addEventListener('click', () => this._handleEditButton(button)));
    }
    this.components = {
      mesh: {
        unitSelector: '[data-mesh-unit]',
        cardSelector: '[data-mesh-product]',
        groupSelector: '[data-mesh-group]',
        qty: 0,
        id: 0,
        price: 0,
      },
      meshScrews: {
        unitSelector: '[data-mesh-screw-unit]',
        cardSelector: '[data-mesh-screw-product]',
        groupSelector: '[data-mesh-group]',
        qty: 0,
        id: 0,
        price: 0,
        screwType: "Mesh",
      },
      saddles: {
        unitSelector: '[data-saddle-unit]',
        cardSelector: '[data-saddle-product]',
        groupSelector: '[data-saddle-group]',
        qty: 0,
        id: 0,
        price: 0,
      },
      saddleScrews: { 
        unitSelector: '[data-saddle-screw-unit]',
        cardSelector: '[data-saddle-screw-product]',
        groupSelector: '[data-saddle-group]',
        qty: 0,
        id: 0,
        price: 0,
        screwType: "Saddle",
      },
      trim: {
        unitSelector: '[data-trim-unit]',
        cardSelector: '[data-trim-product]',
        groupSelector: '[data-trim-group]',
        qty: 0,
        id: 0,
        price: 0,
      },
      trimScrews: {
        unitSelector: '[data-trim-screw-unit]',
        cardSelector: '[data-trim-screw-product]',
        groupSelector: '[data-trim-group]',
        qty: 0,
        id: 0,
        price: 0,
        screwType: "Trim",
      }
    }
    this.backButton = this.querySelector('.kit-builder__back');
    this.backButton.addEventListener('click', (event) => this._handleBackButton(event));
  }

  init() {
    this.closest('.kit-builder__summary').style.display = 'block';
    this._fetchProductData();
    this._updateTotalPrice();
  }

  _fetchProductData() {
    Object.values(this.components).forEach((component) => {
      if(component.handle){
        fetch(`/products/${component.handle}?view=kit-product`).then(response => response.text())
        .then(product => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(product, 'text/html');
    
          const staticProduct = doc.querySelector('[data-section-type="static-product"]'); 
          this.productSettings = JSON.parse(staticProduct.innerHTML); 
          this.product = this.productSettings.product;
          if(component.matchMesh === true) {
            this.variant = this.product.variants.find(variant => variant.title == component.id);
            component.id = this.variant.id;
          } else {
            this.variant = this.product.variants.find(variant => variant.id == component.id);
          }
          if(this.variant) component.price = this.variant.price;

          //if(this.variant) component.availableQty = this.variant.total_inventory;

          this._updateProductCards(component.cardSelector, this.product, this.variant);
          this._updateLineItems(component.cardSelector, this.product, this.variant);
          this._updateTotalPrice();
        })
        .catch()
      } 
      if(!component.handle){
        this._removeProductCards(component.cardSelector);
        this._removeLineItems(component.groupSelector, component.cardSelector);
      }
    });
    
  }

  _updateProductCards(selector, product, variant) {
    this.card = this.querySelector(`.kit-summary__products > ${selector}`);
    if(!this.card) return;
    this.card.style.display = 'flex';
    this.cardTitle = this.card.querySelector('.kit-builder__heading--h6.should-update');
    if(this.cardTitle) this.cardTitle.innerText = product.title;
    this.variantImage = variant.featured_image;
    if(this.variantImage) this.updateImageSrc(this.card.querySelector('.kit-summary__image--wrapper img'), `${this.variantImage.src}&width=800`);
    this.card.querySelector('.kit-builder__swatch').style.background = `var(--${variant.title.replace(' ', '')})`;
    this.card.querySelector('.kit-summary__line-item--colour > span').innerHTML = `<span>${variant.title}<sup>®</sup></span>`;
    setTimeout(() => {
      setLoadingState(false);
    }, 1000);
  }

  _updateLineItems(selector, product, variant) {
    this.lineItem = this.querySelector(`.kit-summary__line-item-group ${selector}`);
    if(!this.lineItem) return;
    this.lineItem.style.display = 'flex';
    this.lineItem.closest('.kit-summary__line-item-group').style.display = 'block';
    this.lineItemTitle = this.lineItem.querySelector('.kit-summary__line-item--title.should-update');
    if(this.lineItemTitle) this.lineItemTitle.innerText = product.title;
    this.lineItem.querySelector('.kit-builder__swatch').style.background = `var(--${variant.title.replace(' ', '')})`;
    this.lineItem.querySelector('.kit-summary__line-item--colour > span').innerHTML = `<span>${variant.title}<sup>®</sup></span>`;
  }

  _removeProductCards(selector) {
    this.card = this.querySelector(`.kit-summary__products > ${selector}`);
    if(!this.card) return;
    this.card.style.display = 'none';
  }

  _removeLineItems(group, item) {
    this.lineItemGroup = this.querySelector(`${group}`);
    if(this.lineItemGroup) this.lineItemGroup.style.display = 'none';
    this.lineItem = this.querySelector(`.kit-summary__line-item-group ${item}`);
    if(this.lineItem) this.lineItem.style.display = 'none';
  }

  _updateTotalPrice() {
    this.totalPrice = 0;
    Object.values(this.components).forEach((component) => {
      this.totalPrice = this.totalPrice + (component.price * component.qty);
    });
    this.discountValue = 1 - (this.discount / 100);
    this.priceElement.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', (this.totalPrice / 100.00 * this.discountValue).toFixed(2));

    if(this.discount > 0) {
      this.compareAtPriceElement.style.display = 'block';
      this.compareAtPriceElement.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', (this.totalPrice / 100.00).toFixed(2));
    } else {
      this.compareAtPriceElement.style.display = 'none';
      this.compareAtPriceElement.innerHTML = Theme.kitBuilder.money_format.replace('{{amount}}', (this.totalPrice / 100.00).toFixed(2));
    }
    
  }

  setProduct(id) {
    this.productId = id;
  }

  getProduct() {
    return this.productId;
  }

  fetchPreselectedColor(component) {
    if(this.components[component].color) {
      return this.components[component].color;
    } else {
      return false;
    }
  }

  toggleScrewQuantities(type) {
    if(type === 'mesh') {
      this.components.meshScrews.qty = this.components.saddleScrews.qty;
      this.components.meshScrews.handle = this.components.saddleScrews.handle;
      this.components.meshScrews.id = this.components.saddleScrews.id;
      this.components.meshScrews.matchMesh = false;
      this.components.saddleScrews.qty = 0;
      delete this.components.saddleScrews.handle;
      delete this.components.saddles.handle;
      this.components.saddles.price = 0;
      this.components.saddleScrews.id = 0;
      this.querySelectorAll(this.components.meshScrews.unitSelector).forEach((unit) => {
        unit.innerText = this.components.meshScrews.qty;
      })
    } else {
      if(this.components.saddleScrews.qty < this.components.meshScrews.qty) {
        this.components.saddleScrews.qty = this.components.meshScrews.qty;
        this.components.saddleScrews.handle = this.components.meshScrews.handle;
        this.components.saddleScrews.id = this.components.meshScrews.id;
        this.components.meshScrews.matchMesh = true;
        this.components.meshScrews.qty = 0;
        delete this.components.meshScrews.handle;
        this.components.meshScrews.id = 0;
      }
    }   
  }
  
  updateQuantity(qty) {
    this.components.mesh.qty = qty;
    this.components.trim.qty = qty;
    this.components.saddles.qty = Math.ceil(qty * this.saddleMultiplier);
    this.components.saddleScrews.qty = Math.ceil(qty * this.saddleScrewMultiplier);
    this.components.trimScrews.qty = Math.ceil(qty * this.trimScrewMultiplier);
    this.components.meshScrews.qty = Math.ceil(qty * this.meshScrewMultiplier);
    this._updateQuantityElements();
    this.querySelector('kit-quantity-selector [data-quantity-input]').value = qty;
    this._updateTotalPrice()
  }



  setMeshScrews(product, variantId, handle, color) {
    if(variantId) {
      if(variantId === 'Dark Brown') {
        this.components[product].id = 'Loft';
      } else if(variantId === 'Terracotta') {
        this.components[product].id = 'Terrain';
      } else {
        this.components[product].id = variantId;
      }
    }
    this.components[product].handle = handle;
    if(color) {
      if(color === 'Dark Brown') {
        this.components[product].color = 'Loft';
      } else if(color === 'Terracotta') {
        this.components[product].color = 'Terrain';
      } else {
        this.components[product].color = color;
      }
    }
    this.components[product].matchMesh = true;
  }

  updateVariant(product, variantId, handle, color) {
    this.components[product].id = parseInt(variantId);
    this.components[product].handle = handle;
    if(color) this.components[product].color = color;
    if(product == 'mesh') {
      Object.values(this.components).forEach((component) => {
        if(!component.color) {
          component.color = color;
        }
      });
    }
  }

  _updateQuantityElements() {
    Object.values(this.components).forEach((component) => {
      this.querySelectorAll(component.unitSelector).forEach((unit) => {
        unit.innerText = component.qty;
      })
    });
  }

  updateImageSrc(imageElement, newImageUrl) {
    this.tempImage = new Image();
    this.tempImage.onload = () => {
      imageElement.src = newImageUrl;
      imageElement.srcset = this.tempImage.srcset;
    };
    this.tempImage.src = newImageUrl;
  }

  _handleAddToCart(e, button) {
    e.preventDefault();
    button.classList.add('processing');
    button.disabled = true;
    let bundleId = Date.now();
    let formData = {
      items: [],
      attributes: {} // Add attributes here
    };

        // Get all elements with class 'color_handle_ps'
    const preOrderElements = document.querySelectorAll('.activeme');
    const isPreOrder = preOrderElements.length > 0; 
    
    for (let componentName in this.components) {
      let component = this.components[componentName];
      if (component.handle) {
        let item = {
          id: component.id,
          quantity: component.qty,
          properties: {
            _bundleName: this.kitName,
            _retailDiscount: this.retailDiscount,
            _tradeDiscount: this.tradeDiscount,
            _wholesaleDiscount: this.wholesaleDiscount,
          }
        };
        item.properties['_bundleId'] = bundleId;
        item.properties['Kit name'] = this.kitName;
        // if (this.internalOrder) item.properties['_internalOrder'] = "true";
        if (component.screwType) {
          item.properties['Screw type'] = component.screwType;
        }


     // Check if any matching 'color_handle_ps' has a non-empty 'data-varid' and matching 'data-product-handle'
      preOrderElements.forEach(preOrderElement => {
          let varId = preOrderElement.getAttribute('data-varid')?.trim(); // Get 'data-varid' and trim spaces

          if (varId && varId === component.id.toString()) {
            console.log('PPPP ---- ',varId + component.id);
            let preOrderMessage = preOrderElement.querySelector('.simple_preorder_msg')?.textContent.trim() || "true";
            preOrderMessage = preOrderMessage.replace(/^Pre-Order - /i, '');
            item.properties['Pre-order'] = preOrderMessage;
            //item.properties['Pre-order Date'] = preOrderElement.getAttribute('data-preorderdate') || "N/A"; // Add Pre-order date if available
          }
        });

       
        
        formData.items.push(item);
      }
    }


     if (isPreOrder) {
    formData.attributes['Pre order'] = "true"; 
}

/*let preOrderItemAdded = false;

   preOrderElements.forEach((preOrderElement) => {
    if (!preOrderItemAdded) {
        formData.items.push({
            id: 46316572246238,
            quantity: 1, // Adjust quantity as needed
            properties: {
              
            }
        });
        preOrderItemAdded = true; // Ensure it's added only once
    }
});*/

    

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      console.log(response.status, response.message)
      if (response.status === 422) {
        this._onError(response.description);
      } else {
        this._onSuccess();
      }
      button.classList.remove('processing');
      button.disabled = false;
    })
    .catch((error) => {
      console.log(error)
      this._onError(`Not enough components left in stock. Contact us for a timeframe on resupply or recommendations on alternative colours.`);
    });
  }

  _onSuccess() {
    document.querySelector('kit-popup').init();    
  }

  _onError(description) {
    this.errorContainer = document.createElement('div');
    const productTitle = description.split("'")[1];
    this.errorContainer.innerText = `Not enough ${productTitle} left in stock. Contact us for a timeframe on resupply or recommendations on alternative colours.`
    this.querySelector('.error-container').append(this.errorContainer);
  }

  _handleEditClick(e, step) {
    e.preventDefault();
    if(step.classList.contains('complete') || step.classList.contains('current-step')) {
      this.stepType = step.dataset.step;
      this.nextStep = document.querySelector(`[data-step="${this.stepType}"]`);
      if(this.nextStep){
        setLoadingState(true);
        document.querySelectorAll('.section--kit-step').forEach((section) => section.style.display = 'none');
        this.nextStep.style.display = 'block';
        setLoadingState(false);
      }
    } else {
      return;
    }
  }

  _handleEditButton(button) {
    this.editStep = button.dataset.step;
    if(this.editStep) {
      setLoadingState(true);
        document.querySelectorAll('.section--kit-step').forEach((section) => section.style.display = 'none');
        document.querySelector(`${this.editStep}`).style.display = 'block';
        setLoadingState(false);
    }
  }

  _handleBackButton(e) {
    e.preventDefault();
    setLoadingState(true);
    this.style.display = 'none';
    this.lastStepValue = this.backButton.dataset.lastStep;
    if(this.lastStepValue == 'trim') {
      this.lastStep = document.querySelector('trim-color');
    } else {
      if(this.lastStepValue == 'saddles') {
        this.lastStep = document.querySelector('saddle-color');
      } else {
        this.lastStep = document.querySelector('mesh-color');
      }
    }
    this.lastStep.init();
  }
}

if (!window.customElements.get('kit-summary')) {
  window.customElements.define('kit-summary', KitSummary);
}


class KitPopup extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('.kit-builder__overlay');
    this.helperText = this.querySelector('[data-screw-color-helper]');
    
    this.helperLink = this.querySelector('.kit-builder__helper-link');
    if(this.helperLink) this.helperLink.addEventListener('click', () => this._handleHelperText(true));
    
    this.helperTextClose = this.querySelector('.kit-builder__screw-helper--close');
    if(this.helperTextClose) this.helperTextClose.addEventListener('click', () => this._handleHelperText(false));
  }

  init() {
    this.content.style.opacity = '0';
    this.content.style.display = 'flex';
    setTimeout(() => {
      this.content.style.opacity = '1';
    }, 500)
  }

  _handleHelperText(show) {
    if(show) {
      this.helperText.style.display = 'block';
      setTimeout(() => {
        this.helperText.style.opacity = '1';
      }, 200)
    } else {
      this.helperText.style.opacity = '0';
      
      setTimeout(() => {
        this.helperText.style.display = 'none';
      }, 200)
    }
  }
}

if (!window.customElements.get('kit-popup')) {
  window.customElements.define('kit-popup', KitPopup);
}

class KitFooter extends HTMLElement {
  constructor() {
    super();
    this._setInstallationHref();

    this.kitSteps = this.querySelectorAll('[data-kit-step]');
    if(this.kitSteps) this.kitSteps.forEach((step) => step.addEventListener('click', (event) => this._handleStepClick(event, step)));
    this._updateScrollPosition()
  }

  _setInstallationHref() {
    this.installationStep = this.querySelector('[data-installation-step]');
    this.currentParam = window.location.search.replace('?kit=', '').split('-');
    if(this.currentParam) {
      if(this.currentParam[0] === 'klip' || this.currentParam[0] === 'trim') {
        this.installationStep.href = `/pages/roof-type/${this.currentParam[0]}-${this.currentParam[1]}?kit=${this.currentParam[0]}-${this.currentParam[1]}`;
      } else {
        this.installationStep.href = `/pages/roof-type/${this.currentParam[0]}?kit=${this.currentParam[0]}`;
      }
    }
  }

  _handleStepClick(e, step) {
    e.preventDefault();
    if (step.classList.contains('complete') || step.classList.contains('current-step')) {
      this.stepType = step.dataset.step;
      this.nextStep = document.querySelector(`[data-step="${this.stepType}"]`);
      if (this.nextStep) {
        setLoadingState(true);
        document.querySelectorAll('.section--kit-step').forEach((section) => section.style.display = 'none');
        if (this.stepType === 'kit-summary') {
          this.nextStep.init();
        } else {
          this.nextStep.style.display = 'block';
          setLoadingState(false);
        }
  
        // Change class of clicked step to current-step
        step.classList.remove('complete');
        step.classList.add('current-step');
  
        // Remove complete and current-step classes from steps to the right
        let nextSibling = step.nextSibling;
        while (nextSibling) {
          if (nextSibling.nodeType === 1 && (nextSibling.classList.contains('complete') || nextSibling.classList.contains('current-step'))) {
            nextSibling.classList.remove('complete');
            nextSibling.classList.remove('current-step');
          }
          nextSibling = nextSibling.nextSibling;
        }
      }
    } else {
      return;
    }
  }

  updatePlaceholder(context, value) {
    this.element = this.querySelector(`[data-step=${context}]`);
    this.element.classList.add('complete');
    this.element.classList.remove('current-step');
    let nextStep = this.element.nextSibling;
    while (nextStep && nextStep.nodeType !== 1) {
      nextStep = nextStep.nextSibling;
    }
    if (nextStep) {
      if(!nextStep.classList.contains('complete')) {
        nextStep.classList.add('current-step');
      }
    }
    this.placeholder = this.element.querySelector(`[data-choice-placeholder]`);
    if(this.placeholder) this.placeholder.innerText = value;
    setTimeout(() => {
      this._updateScrollPosition();
    }, 200);
  }

  _updateScrollPosition() {
    this.currentStep = this.querySelector('.current-step');
    if (this.currentStep) {
      this.currentStepRect = this.currentStep.getBoundingClientRect();
      const containerWidth = this.offsetWidth; // Width of the container
      const initialScrollLeft = this.scrollLeft; // Initial scroll position
      const scrollAmount = this.currentStepRect.right - containerWidth + initialScrollLeft;
  
      const duration = 500; // Duration of the animation in milliseconds
      const startTime = performance.now(); // Reset the start time
  
      const scrollToSmooth = (timestamp) => {
        const elapsedTime = timestamp - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const newPosition = initialScrollLeft + (scrollAmount - initialScrollLeft) * this.easeInOutCubic(progress);
        this.scrollLeft = newPosition;
        if (progress < 1) {
          requestAnimationFrame(scrollToSmooth);
        }
      };
  
      requestAnimationFrame(scrollToSmooth);
    }
  }
    
  easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }
}


if(!window.customElements.get('kit-footer')) {
  window.customElements.define('kit-footer', KitFooter);
}

class KitFooterAlt extends KitFooter {
  constructor() {
    super();
    this.init();
  }

  init() {
    if(window.location.search) {
      this.searchParts = window.location.search.split('-');
      this.path = window.location.pathname.split('/');
      if(this.path[2] === 'roof-type') {
        this.roofType = `${this.path[3].replace('-', '')} Gutter Guard`;
      }

      if(this.path[2] === 'installation-type') {
        if(this.path[3].includes('klip-lok')) {
          this.roofType = `KlipLok Gutter Guard`;
          this.installationType = `${this.searchParts[2]} ${this.searchParts[3]}`;
        } else if(this.path[3].includes('trim-dek')) {
           this.roofType = `TrimDek Gutter Guard`;
           this.installationType = `${this.searchParts[2]} ${this.searchParts[3]}`;
        } else {
          this.roofType = `${this.searchParts[0].replace(`?kit=`, ``)} Gutter Guard`;
          this.installationType = `${this.searchParts[1]} ${this.searchParts[2]}`;
        }
      }

      this.updatePlaceholder('roof-type', this.toTitleCase(this.roofType));
      if(this.installationType) {
        this.updatePlaceholder('installation-type', this.toTitleCase(this.installationType));
      }
    }
  }

  toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }
  
  updatePlaceholder(context, value) {
    this.element = this.querySelector(`[data-step=${context}]`);
    this.placeholder = this.element.querySelector(`[data-choice-placeholder]`);
    if(this.placeholder) this.placeholder.innerText = value;
    setTimeout(() => {
      this._updateScrollPosition();
    }, 200);
  }
}

if(!window.customElements.get('kit-footer-alt')) {
  window.customElements.define('kit-footer-alt', KitFooterAlt);
}
